<script setup lang="ts">
    import AppText from '@/components/AppText.vue';
    import { useApprovePlanViewModel } from '@/views/3d-planner/components/useApprovePlanViewModel';
    import { PLANNER_TARGETS } from '@/domain/analytics/analyticsTargets';

    const props = withDefaults(
        defineProps<{
            valid?: boolean;
        }>(),
        {
            valid: true,
        },
    );

    const vm = useApprovePlanViewModel(() => props.valid);
</script>

<template>
    <div class="approve-plan pb-0 mt-4">
        <app-button-cta
            class="approve-btn"
            :data-analytics-id="PLANNER_TARGETS.generatePlanButton"
            prepend-icon="mdi-check"
            :loading="vm.isSaving.value"
            :disabled="vm.buttonDisabled.value"
            @click="vm.submit"
        >
            {{ vm.label.value }}
        </app-button-cta>
        <app-tooltip v-if="vm.act.value === 'none'" activator="parent" location="top">
            <span>You do not have permission to approve this case. </span>
        </app-tooltip>
        <app-tooltip v-else-if="!valid" activator="parent" location="top">
            <span>There are incomplete changes. </span>
        </app-tooltip>
        <app-tooltip
            v-else-if="!vm.changesNotPlannedYet.value && !vm.proposalAwaitingApproval.value"
            activator="parent"
            location="top"
        >
            <span>There are no changes to approve. </span>
        </app-tooltip>
        <app-hint v-if="vm.changesNotPlannedYet.value" class="pt-2 d-flex justify-start">
            <app-text inline>Changes have been made since plan creation.</app-text>
            <app-tooltip max-width="450" activator="parent" location="bottom" open-on-hover>
                <v-container outline class="rounded-sm pa-0 ma-0">
                    <p class="font-weight-bold">
                        Changes have been made since the Manual Plan was created
                    </p>
                    <p>
                        If you wish these changes to be represented in the downloadable manual Plan
                        for this Case, click the button once you&rsquo;re happy with your changes.
                    </p>
                </v-container>
            </app-tooltip>
        </app-hint>
        <app-hint v-else-if="vm.proposalHint.value" class="pt-2 d-flex justify-start">
            <app-text inline>{{ vm.proposalHint.value }}</app-text>
        </app-hint>
    </div>
</template>

<style scoped lang="scss">
    .approve-btn {
        width: 323px !important;
    }

    .approve-plan {
        text-align: center;
    }
</style>
